import { ASSET_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    getAssetTypeLoading: false,
    getAssetTypeSuccess: false,
    getAssetTypeFailure: false,
    getAssetTypeError: null,
    assetTypeList: [],
    addAssetTypeLoading: false,
    addAssetTypeSuccess: false,
    addAssetTypeFailure: false,
    addAssetTypeError: null
}

export const assetTypeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ASSET_REQUEST.RESET_ASSET_TYPE:
            return {
                ...state,
                addAssetTypeLoading: false,
                addAssetTypeSuccess: false,
                addAssetTypeFailure: false,
                addAssetTypeError: null
            }
        case ASSET_REQUEST.GET_ASSETS_TYPE_REQUEST:
            return {
                ...state,
                getAssetTypeLoading: true,
                getAssetTypeFailure: false,
                getAssetTypeSuccess: false,
                getAssetTypeError: null
            }
        case ASSET_REQUEST.GET_ASSETS_TYPE_SUCCESS:
            return {
                ...state,
                getAssetTypeLoading: false,
                getAssetTypeFailure: false,
                getAssetTypeSuccess: true,
                getAssetTypeError: null,
                assetTypeList: action.payload
            }
        case ASSET_REQUEST.GET_ASSETS_TYPE_FAILURE:
            return {
                ...state,
                getAssetTypeLoading: false,
                getAssetTypeFailure: true,
                getAssetTypeSuccess: false,
                getAssetTypeError: action.payload
            }
        case ASSET_REQUEST.ADD_ASSETS_TYPE_REQUEST:
            return {
                ...state,
                addAssetTypeLoading: true,
                addAssetTypeFailure: false,
                addAssetTypeSuccess: false,
                addAssetTypeError: null
            }
        case ASSET_REQUEST.ADD_ASSETS_TYPE_SUCCESS:
            let asset_type_list = state.assetTypeList;
            action.payload = { ...action.payload, id: asset_type_list.length }
            asset_type_list.push(action.payload);
            return {
                ...state,
                addAssetTypeLoading: false,
                addAssetTypeFailure: false,
                addAssetTypeSuccess: true,
                addAssetTypeError: null,
                assetTypeList: asset_type_list
            }
        case ASSET_REQUEST.ADD_ASSETS_TYPE_FAILURE:
            return {
                ...state,
                addAssetTypeLoading: false,
                addAssetTypeFailure: true,
                addAssetTypeSuccess: false,
                addAssetTypeError: action.payload
            }
        case ASSET_REQUEST.DELETE_ASSETS_TYPE_REQUEST:
            return {
                ...state,
                addAssetTypeLoading: true,
                addAssetTypeFailure: false,
                addAssetTypeSuccess: false,
                addAssetTypeError: null
            }
        case ASSET_REQUEST.DELETE_ASSETS_TYPE_SUCCESS:
            let assettype_list = state.assetTypeList;
            for (var i = 0; i < assettype_list.length; i++) {
                if (assettype_list[i].id === action.payload) {
                    assettype_list.splice(i, 1)
                }
            }
            return {
                ...state,
                addAssetTypeLoading: false,
                addAssetTypeFailure: false,
                addAssetTypeSuccess: true,
                addAssetTypeError: null,
                assetTypeList: assettype_list
            }
        case ASSET_REQUEST.DELETE_ASSETS_TYPE_FAILURE:
            return {
                ...state,
                addAssetTypeLoading: false,
                addAssetTypeFailure: true,
                addAssetTypeSuccess: false,
                addAssetTypeError: action.payload
            }
        case ASSET_REQUEST.EDIT_ASSETS_TYPE_REQUEST:
            return {
                ...state,
                addAssetTypeLoading: true,
                addAssetTypeFailure: false,
                addAssetTypeSuccess: false,
                addAssetTypeError: null
            }
        case ASSET_REQUEST.EDIT_ASSETS_TYPE_SUCCESS:
            let assetType_list = state.assetTypeList;
            for (var i = 0; i < assetType_list.length; i++) {
                if (assetType_list[i].id === action.payload.id) {
                    assetType_list[i] = action.payload
                }
            }
            return {
                ...state,
                addAssetTypeLoading: false,
                addAssetTypeFailure: false,
                addAssetTypeSuccess: true,
                addAssetTypeError: null,
                assetTypeList: assetType_list
            }
        case ASSET_REQUEST.EDIT_ASSETS_TYPE_FAILURE:
            return {
                ...state,
                addAssetTypeLoading: false,
                addAssetTypeFailure: true,
                addAssetTypeSuccess: false,
                addAssetTypeError: action.payload
            }
        default:
            return state;
    }
}